import { type CSSProperties } from 'react';

/**
 * 메뉴 이름 옆의 별 — <b>사이드바와 화면 위 탭이 같은 별</b>을 쓴다 (V325 · 사용자 지시 2026-09-30
 * 「메뉴들 이름 옆에 사이드바에 있는 것 처럼 별표를 추가할 수 있게」).
 *
 * <p>별이 사이드바에만 있던 동안 <b>담을 수 있는 것은 맨 윗줄뿐</b>이었다 — 하위는 화면 맨 위의
 * 탭으로 올라갔고({@code MenuTabs}) 거기에는 별이 없었기 때문이다. 「인사관리 › 인사자료 › 연차
 * 촉진」 처럼 실제로 매일 여는 자리는 대개 그 아래 두 단인데, 그것을 담을 손이 없었다.
 *
 * <p>담는 값은 여전히 <b>메뉴 키</b> 하나다({@code useMenuFavorites}) — 깊이를 따지지 않으므로
 * 탭에서 담은 것과 사이드바에서 담은 것이 같은 목록에 같은 자격으로 선다.
 *
 * @param on       지금 담겨 있는가 — 켜지면 금색으로 칠한다
 * @param className 보이고 숨는 규칙과 <b>손 얹은 바탕</b>은 부르는 쪽이 정한다. 사이드바는 마우스를
 *                 올린 줄에만 세우고(`opacity-0 group-hover:…`), 탭 줄은 옅게 늘 세운다 — 패드에는
 *                 hover 가 없다. 바탕색을 여기서 굳히지 않는 이유는 <b>고른 탭 속</b>에 들어가기
 *                 때문이다 — 남색 칸 안에서 밝은 회색 동그라미는 구멍처럼 보인다.
 */
export function MenuFavoriteStar({
  on,
  label,
  onToggle,
  size = 13,
  className = '',
  style,
}: {
  on: boolean;
  label: string;
  onToggle: () => void;
  size?: number;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <button
      type="button"
      onClick={(event) => {
        // 부모가 링크·토글이다. 별을 눌렀는데 화면이 넘어가면 누른 뜻과 다른 일이 일어난다.
        event.preventDefault();
        event.stopPropagation();
        onToggle();
      }}
      aria-label={`${label} 즐겨찾기 ${on ? '빼기' : '담기'}`}
      aria-pressed={on}
      title={`즐겨찾기 ${on ? '빼기' : '담기'}`}
      className={`rounded-lg ${className}`}
      style={{
        padding: '6px',
        flexShrink: 0,
        lineHeight: 0,
        color: on ? '#f59e0b' : 'var(--text-muted)',
        ...style,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={on ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.8 6.2 20.9l1.1-6.5L2.6 9.8l6.5-.9z" />
      </svg>
    </button>
  );
}
